import { render, staticRenderFns } from "./PolyMethylamine.vue?vue&type=template&id=4f487dac&scoped=true&"
import script from "./PolyMethylamine.vue?vue&type=script&lang=js&"
export * from "./PolyMethylamine.vue?vue&type=script&lang=js&"
import style0 from "./PolyMethylamine.vue?vue&type=style&index=0&id=4f487dac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f487dac",
  null
  
)

export default component.exports